import React, { useEffect, useState } from 'react';
import { requestCardUserDetail } from '@/models/card';
import { Button, Modal } from 'antd';
import AsyncWrapper from '../AsyncWrapper';
import CardUserView from './CardUser';
import { CreditCardOutlined } from '@ant-design/icons';

type Props = {
  onClose: () => void;
  cardUserSn?: string;
};
const CardUserModal: React.FC<Props> = ({ cardUserSn, onClose }: Props) => {
  const [visible, setVisible] = useState(false);
  const {
    payload: cardUser,
    send: getCardUserDetail,
    loading,
    error,
    reset,
  } = requestCardUserDetail();

  useEffect(() => {
    if (cardUserSn) {
      setVisible(true);
      getCardUserDetail({ params: { cardUserSn } }).then();
    } else {
      setVisible(false);
      reset();
    }
  }, [cardUserSn]);

  const afterClose = () => {
    onClose();
  };

  return (
    <Modal
      closable={false}
      destroyOnHidden
      open={visible}
      afterClose={afterClose}
      okText={'关闭'}
      title={
        <>
          <CreditCardOutlined /> <span>套餐卡</span>
        </>
      }
      footer={
        <>
          <Button
            onClick={() => {
              setVisible(false);
            }}>
            关闭
          </Button>
        </>
      }
      width={500}
      onCancel={() => {
        setVisible(false);
      }}>
      <AsyncWrapper loading={loading} error={error} render={!!cardUser}>
        {() => {
          return <CardUserView card={cardUser} />;
        }}
      </AsyncWrapper>
    </Modal>
  );
};

export default CardUserModal;
